import { defineMessages } from 'react-intl';
var messages = defineMessages({
  title: {
    id: "LessonDetails.Attachments.title",
    defaultMessage: [{
      "type": 0,
      "value": "Attachments"
    }]
  },
  type: {
    id: "LessonDetails.Attachments.type",
    defaultMessage: [{
      "type": 0,
      "value": "Type:"
    }]
  },
  size: {
    id: "LessonDetails.Attachments.size",
    defaultMessage: [{
      "type": 0,
      "value": "Size:"
    }]
  },
  uploaded: {
    id: "LessonDetails.Attachments.uploaded",
    defaultMessage: [{
      "type": 0,
      "value": "Uploaded:"
    }]
  },
  download: {
    id: "LessonDetails.Attachments.download",
    defaultMessage: [{
      "type": 0,
      "value": "Download"
    }]
  },
  open: {
    id: "LessonDetails.Attachments.open",
    defaultMessage: [{
      "type": 0,
      "value": "Open"
    }]
  }
});
export default messages;